// Chakra Imports
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import React, { useEffect, useState } from "react";
import * as Sentry from "@sentry/react";
// Assets
import {
  MdSettings,
  MdFullscreen,
  MdOutlineFullscreenExit,
  MdRefresh,
  MdBugReport,
} from "react-icons/md";
import ConfiguratorRadio from "./ConfiguratorRadio";
export default function HeaderLinks(props: { [x: string]: any }) {
  const { theme, setTheme, darkmode, setDarkmode } = props;
  //eslint-disable-next-line
  const { isOpen, onOpen, onClose } = useDisclosure();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [active, setActive] = useState("Purple");
  const btnRef = React.useRef();
  // const [fullscreen, setFullscreen] = useState(false);
  // Chakra Color Mode
  const resetTheme = () => {
    const newTheme = {
      "--shadow-100": "transparent",
      "--background-100": "#F4F7FE",
      "--background-900": "#070f2e",
      "--color-50": "#F0EFFF",
      "--color-100": "#E3E1FF",
      "--color-200": "#C9C5FF",
      "--color-300": "#AFA8FF",
      "--color-400": "#948BFF",
      "--color-500": "#5746EF",
      "--color-600": "#4635CC",
      "--color-700": "#3527A8",
      "--color-800": "#241A85",
      "--color-900": "#130E62",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeGreen = () => {
    const newTheme = {
      "--color-50": "#E1FFF4",
      "--color-100": "#BDFFE7",
      "--color-200": "#7BFECE",
      "--color-300": "#39FEB6",
      "--color-400": "#01F99E",
      "--color-500": "#01B574",
      "--color-600": "#01935D",
      "--color-700": "#016B44",
      "--color-800": "#00472D",
      "--color-900": "#002417",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeOrange = () => {
    const newTheme = {
      "--color-50": "#FFF7EB",
      "--color-100": "#FFF1DB",
      "--color-200": "#FFE2B8",
      "--color-300": "#FFD28F",
      "--color-400": "#FFC46B",
      "--color-500": "#FFB547",
      "--color-600": "#FF9B05",
      "--color-700": "#C27400",
      "--color-800": "#855000",
      "--color-900": "#422800",
      "--color-950": "#1F1200",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeRed = () => {
    const newTheme = {
      "--color-50": "#FCE8E8",
      "--color-100": "#FAD1D1",
      "--color-200": "#F4A4A4",
      "--color-300": "#EF7676",
      "--color-400": "#EA4848",
      "--color-500": "#E31A1A",
      "--color-600": "#B71515",
      "--color-700": "#891010",
      "--color-800": "#5B0B0B",
      "--color-900": "#2E0505",
      "--color-950": "#170303",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeBlue = () => {
    const newTheme = {
      "--color-50": "#EBEFFF",
      "--color-100": "#D6DFFF",
      "--color-200": "#ADBFFF",
      "--color-300": "#8AA3FF",
      "--color-400": "#6183FF",
      "--color-500": "#3965FF",
      "--color-600": "#0036FA",
      "--color-700": "#0029BD",
      "--color-800": "#001B7A",
      "--color-900": "#000D3D",
      "--color-950": "#00071F",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeTeal = () => {
    const newTheme = {
      "--color-50": "#EBFAF8",
      "--color-100": "#D7F4F2",
      "--color-200": "#AAE9E4",
      "--color-300": "#82DED6",
      "--color-400": "#59D4C9",
      "--color-500": "#33C3B7",
      "--color-600": "#299E94",
      "--color-700": "#1F756E",
      "--color-800": "#144D48",
      "--color-900": "#0B2826",
      "--color-950": "#051413",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeBrand = () => {
    const newTheme = {
      "--color-50": "#EFEBFF",
      "--color-100": "#E9E3FF",
      "--color-200": "#422AFB",
      "--color-300": "#422AFB",
      "--color-400": "#7551FF",
      "--color-500": "#422AFB",
      "--color-600": "#3311DB",
      "--color-700": "#02044A",
      "--color-800": "#190793",
      "--color-900": "#11047A",
    };
    setTheme(newTheme);
  };
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const changeThemeIndigo = () => {
    const newTheme = {
      "--color-50": "#F0EFFF",
      "--color-100": "#E3E1FF",
      "--color-200": "#C9C5FF",
      "--color-300": "#AFA8FF",
      "--color-400": "#948BFF",
      "--color-500": "#5746EF",
      "--color-600": "#4635CC",
      "--color-700": "#3527A8",
      "--color-800": "#241A85",
      "--color-900": "#130E62",
    };
    setTheme(newTheme);
  };
  useEffect(() => {
    if (theme["--color-500"] === "#01B574") {
      setActive("Green");
    } else if (theme["--color-500"] === "#FFB547") {
      setActive("Orange");
    } else if (theme["--color-500"] === "#E31A1A") {
      setActive("Red");
    } else if (theme["--color-500"] === "#3965FF") {
      setActive("Blue");
    } else if (theme["--color-500"] === "#33C3B7") {
      setActive("Teal");
    } else if (theme["--color-500"] === "#5746EF") {
      setActive("Indigo");
    } else {
      setActive("Purple");
    }
  }, [theme]);
  const [isFullscreen, setIsFullscreen] = useState(false);

  // Watch for fullscreenchange
  useEffect(() => {
    function onFullscreenChange() {
      setIsFullscreen(Boolean(document.fullscreenElement));
    }

    document.addEventListener("fullscreenchange", onFullscreenChange);

    return () =>
      document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);
  return (
    <>
      <button
        ref={btnRef}
        className="h-[18px] min-h-[unset] w-max min-w-[unset] bg-none p-0"
        onClick={onOpen}
      >
        <MdSettings className="h-[18px] w-[18px] text-gray-400 dark:text-white" />
      </button>
      <Drawer
        isOpen={isOpen}
        onClose={onClose}
        placement={document.documentElement.dir === "rtl" ? "left" : "right"}
        blockScrollOnMount={false}
        preserveScrollBarGap={true}
      >
        <DrawerOverlay />
        <DrawerContent className="my-4 ml-0 mr-4 w-[calc(100vw_-_32px)] max-w-[calc(100vw_-_32px)] rounded-2xl bg-white shadow-[-20px_17px_40px_4px_rgba(112,_144,_176,_0.18)] dark:bg-navy-800 dark:shadow-[-22px_32px_51px_4px_#0B1437] sm:ml-4 md:w-[400px] md:max-w-[400px]">
          <DrawerHeader
            px="28px"
            w={{ base: "100%", md: "400px" }}
            pt="24px"
            pb="0px"
          >
            <div
              className="absolute top-[13px] right-[50px] cursor-pointer"
              onClick={() => {
                resetTheme();
                props.setMini(false);
              }}
            >
              <MdRefresh className="h-[22px] w-[22px] text-gray-900 dark:text-white" />
            </div>
            <DrawerCloseButton className="absolute right-[26px] top-[16px] h-4 w-4 text-gray-900 dark:text-white" />
            <div className="flex items-center">
              {/* <div className="mr-5 flex h-12 w-12 rounded-full bg-gradient-to-b from-brand-400 to-brand-600">
                <img alt="" src={ConfiguratorLogo} />
              </div> */}
              <div>
                <p className="text-xl font-bold text-gray-900 dark:text-white">
                  Configurator
                </p>
                {/* <p className="text-md flex font-medium text-gray-600">
                  Horizon UI PRO TS
                  <span className="ml-1.5 flex items-center rounded-3xl bg-brand-50 px-2 text-sm font-semibold text-brand-500 dark:bg-white/10 dark:text-white">
                    v2.0.0
                  </span>
                </p> */}
              </div>
            </div>
            <div className="my-[30px] h-px w-full bg-gray-200 dark:!bg-navy-700" />
          </DrawerHeader>
          <DrawerBody
            overflowY="scroll"
            px="28px"
            pt="0px"
            pb="24px"
            w={{ base: "100%", md: "400px" }}
            maxW="unset"
          >
            <div className="flex flex-col">
              <p className="mb-3 font-bold text-gray-900 dark:text-white">
                Color Mode
              </p>
              <div className="mb-7 flex w-full justify-between gap-5">
                <ConfiguratorRadio
                  onClick={() => {
                    if (darkmode) {
                      document.body.classList.remove("dark");
                      setDarkmode(false);
                      localStorage.setItem("darkMode", "false");
                    }
                  }}
                  active={
                    document.body.classList.contains("dark") ? false : true
                  }
                  label={
                    <p className="font-bold text-gray-900 dark:text-white">
                      Light
                    </p>
                  }
                >
                  <div className="w-[130px] h-[80px] rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center">
                    <div className="w-16 h-10 bg-white rounded shadow-sm" />
                  </div>
                </ConfiguratorRadio>
                <ConfiguratorRadio
                  onClick={() => {
                    if (!darkmode) {
                      document.body.classList.add("dark");
                      setDarkmode(true);
                      localStorage.setItem("darkMode", "true");
                    }
                  }}
                  active={
                    !document.body.classList.contains("dark") ? false : true
                  }
                  label={
                    <p className="font-bold text-gray-900 dark:text-white">
                      Dark
                    </p>
                  }
                >
                  <div className="w-[130px] h-[80px] rounded-lg bg-navy-800 border border-navy-700 flex items-center justify-center">
                    <div className="w-16 h-10 bg-navy-700 rounded shadow-sm" />
                  </div>
                </ConfiguratorRadio>
              </div>
            </div>
            <div className="my-[30px] h-px w-full bg-gray-200 dark:!bg-navy-700" />
            <button
              className="text-md flex h-max w-full items-center justify-center rounded-2xl border-[1px] border-gray-200 bg-[rgba(11,11,11,0)] py-4 font-bold text-gray-900 hover:bg-white hover:shadow-[0px_18px_40px_rgba(112,_144,_176,_0.22)] focus:bg-white focus:shadow-[0px_18px_40px_rgba(112,_144,_176,_0.22)] active:bg-[#F7F9FF] active:shadow-[0px_18px_40px_rgba(112,_144,_176,_0.22)] dark:border-white/20 dark:text-white hover:dark:bg-navy-700 hover:dark:shadow-none focus:dark:bg-navy-700 focus:dark:shadow-none active:dark:bg-white/10 active:dark:shadow-none"
              onClick={() => {
                isFullscreen
                  ? document.exitFullscreen()
                  : document.body.requestFullscreen();
              }}
            >
              {isFullscreen ? "Exit fullscreen" : "Fullscreen mode"}
              {isFullscreen ? (
                <MdOutlineFullscreenExit className="ml-1.5 h-[18px] w-[18px] text-gray-900 dark:text-white" />
              ) : (
                <MdFullscreen className="ml-1.5 h-[18px] w-[18px] text-gray-900 dark:text-white" />
              )}
            </button>
            {window.location.hostname === "localhost" && (
              <>
                <div className="my-[30px] h-px w-full bg-gray-200 dark:!bg-navy-700" />
                <button
                  className="text-md flex h-max w-full items-center justify-center rounded-2xl border-[1px] border-red-200 bg-[rgba(11,11,11,0)] py-4 font-bold text-red-500 hover:bg-red-50 hover:shadow-[0px_18px_40px_rgba(112,_144,_176,_0.22)] dark:border-red-400/20 dark:text-red-400 hover:dark:bg-red-900/20 hover:dark:shadow-none"
                  onClick={() => {
                    Sentry.captureException(new Error("Sentry test error — safe to ignore"));
                    alert("Test error sent to Sentry!");
                  }}
                >
                  Test Sentry
                  <MdBugReport className="ml-1.5 h-[18px] w-[18px]" />
                </button>
              </>
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
